import React, { FC } from "react";

import { ButtonProps as BaseButtonProps } from "@natera/material/lib/button";
import { Button } from "@natera/form";

import "./buttonNoShadow.scss";

const ButtonNoShadow: FC<BaseButtonProps> = (props) => {
  return <Button {...props} className="button-no-shadow"></Button>;
};

export default ButtonNoShadow;
